import type { DateValue } from '@ark-ui/react/date-picker';
import { useCallback, useState } from 'react';

export const useCalendarInteractions = () => {
  const [hoveredDate, setHoveredDate] = useState<DateValue | null>(null);

  const handleDateHover = useCallback(
    (day: DateValue, isCurrentMonth: boolean, isWeekend: boolean, isSelected: boolean) => {
      if (isCurrentMonth && !isWeekend && !isSelected) {
        setHoveredDate(day);
      }
    },
    []
  );

  const handleDateLeave = useCallback(() => {
    setHoveredDate(null);
  }, []);

  const resetHover = useCallback(() => {
    setHoveredDate(null);
  }, []);

  return {
    hoveredDate,
    handleDateHover,
    handleDateLeave,
    resetHover,
  };
};
